import createIcon from '../../createIcon';

/**
 * @component @name Looks6
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgMTVIMTNWMTNIMTFWMTVaTTE5IDNINUMzLjkgMyAzIDMuOSAzIDVWMTlDMyAyMC4xIDMuOSAyMSA1IDIxSDE5QzIwLjEgMjEgMjEgMjAuMSAyMSAxOVY1QzIxIDMuOSAyMC4xIDMgMTkgM1pNMTUgOUgxMVYxMUgxM0MxNC4xIDExIDE1IDExLjg5IDE1IDEzVjE1QzE1IDE2LjExIDE0LjEgMTcgMTMgMTdIMTFDOS45IDE3IDkgMTYuMTEgOSAxNVY5QzkgNy44OSA5LjkgNyAxMSA3SDE1VjlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Looks6 = createIcon('Looks6', [
  [
    'path',
    {
      d: 'M11 15H13V13H11V15ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM15 9H11V11H13C14.1 11 15 11.89 15 13V15C15 16.11 14.1 17 13 17H11C9.9 17 9 16.11 9 15V9C9 7.89 9.9 7 11 7H15V9Z',
      key: 'f8clun',
    },
  ],
]);

export default Looks6;
